module.exports = __webpack_public_path__ + "static/media/familiar-superior.5.50db7998.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/rooms/superior-familiar/images/familiar-superior.5.jpg
// module id = 685
// module chunks = 0